import {combineReducers} from "redux";
import FilesReducer from "store/files/FIlesReducer";
import AuthReducer from "../store/auth/AuthReducer";

const reducers = combineReducers({
    auth: new AuthReducer().reducer,
    files: new FilesReducer().reducer
});

export default reducers;